// Legacy color tokens — now repointed to the central design tokens in theme.js
// so existing imports pick up the PayLoom plum / marigold palette on blush.
// The names below are historical (they predate the rebrand); prefer importing
// `tokens` from "../theme" in new code.
import { tokens } from "../theme";

export const lightGrey = tokens.textMuted; // muted text
export const blueBackGround = tokens.surfaceSubtle; // subtle input surface
export const greyTextColor = tokens.border; // borders / dividers
export const blackTextColor = tokens.text; // body text (ink)
export const blueTextColor = tokens.primary; // links / accents (now plum)
export const whiteColor = tokens.card; // card surface, warm white
export const blueColor = tokens.primary; // primary action (now plum)
